import i18n from "i18next";
import { TFunction } from "i18next";
import { z } from "zod";

import { fallbackLng } from "./config";

export const buildZodLocale = (_: unknown, _t: TFunction) => {
    let fn = z.locales[fallbackLng as keyof typeof z.locales];

    if (i18n.language in z.locales) {
        fn = z.locales[i18n.language as keyof typeof z.locales];
    }

    z.config(fn());
};
